import { Component, Input } from '@angular/core';
import {
  EntityType,
  EventType,
  LogRegistry,
  ValidEvents,
} from 'src/app/core/models/history-log';
import { ITEM_PRICE_RECOMMENDATION_CHANGE_FIELDS } from './log-changes.constant';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-log-changes',
  templateUrl: './log-changes.component.html',
  styleUrls: ['./log-changes.component.scss'],
})
export class LogChangesComponent {
  @Input() entityType: EntityType;
  @Input() eventType: ValidEvents<EntityType>;
  @Input() changes: LogRegistry[EntityType][ValidEvents<EntityType>]['changes'];
  @Input() displayCurrency: { code: string; symbol: string };

  constructor(public sanitizer: DomSanitizer) {}

  readonly EntityType = EntityType;
  readonly EventType = EventType;
  readonly ITEM_PRICE_RECOMMENDATION_CHANGE_FIELDS =
    ITEM_PRICE_RECOMMENDATION_CHANGE_FIELDS;
}
